// extracted by mini-css-extract-plugin
export default {"root":"app-header_root__KlgvY","hidden":"app-header_hidden__x9s-g","leftTemplate":"app-header_leftTemplate__LfP3V","rightTemplate":"app-header_rightTemplate__-CLt9"};